module.exports = __webpack_public_path__ + "img/help_download2.f0f08d69.png";